export default "/assets/images/favicon.ico?f4ea85c4669e7b4824337d8efda79a9d";